import React from 'react';
import { Lock, ArrowRight } from 'lucide-react';

/**
 * BlurredSection — Zone floutée avec overlay et CTA
 * Utilisé pour masquer le contenu premium dans l'audit public simplifié.
 */
export default function BlurredSection({
    children,
    title = "Contenu réservé",
    description = "Débloquez le rapport complet pour accéder à ces informations détaillées.",
    ctaLabel = "Obtenir l'audit complet",
    ctaLink = "#",
    ctaVariant = "primary",
    onCtaClick,
    blurAmount = 6,
    compact = false,
    overlapCards = false,
    className = "",
}) {
    const minH = compact ? 'min-h-[340px]' : 'min-h-[320px]';
    const contentMinH = compact ? 'min-h-[300px]' : 'min-h-[280px]';
    const marginClass = overlapCards ? '-mt-14' : '';
    const gradient = compact
        ? 'bg-gradient-to-b from-white/40 via-white/70 to-white/98'
        : 'bg-gradient-to-b from-white/60 via-white/80 to-white/95';
    return (
        <div className={`relative overflow-hidden rounded-xl ${minH} ${marginClass} ${className}`}>
            {/* Contenu — flou uniforme ou progressif (blurAmount=0 + blurPx sur les enfants) */}
            <div
                className={`${contentMinH} w-full`}
                style={{ filter: blurAmount > 0 ? `blur(${blurAmount}px)` : undefined, pointerEvents: 'none', userSelect: 'none' }}
                aria-hidden="true"
            >
                {children}
            </div>

            {/* Overlay — gradient plus transparent en haut pour l'effet "noiement" */}
            <div className={`absolute inset-0 ${gradient} flex flex-col items-center justify-center px-4 py-6 text-center z-10 ${minH}`}>
                <div className="w-12 h-12 min-w-[3rem] min-h-[3rem] rounded-full flex-shrink-0 flex items-center justify-center mb-3 cta-audit-icon">
                    <Lock size={20} strokeWidth={2.5} className="text-slate-500" aria-hidden />
                </div>
                <h3 className="text-base md:text-lg font-bold text-gray-900 mb-1.5">{title}</h3>
                <p className="text-xs md:text-sm text-gray-500 max-w-sm mb-4">{description}</p>
                <a
                    href={ctaLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={() => onCtaClick && onCtaClick()}
                    className={`inline-flex items-center gap-2 px-6 py-2.5 rounded-xl font-semibold text-sm transition-all duration-300 flex-shrink-0 ${ctaVariant === 'primary' ? 'cta-audit-gratuit' : 'bg-white text-gray-900 border-2 border-gray-200 hover:border-gray-300'}`}
                >
                    {ctaLabel}
                    <ArrowRight size={16} />
                </a>
            </div>
        </div>
    );
}
